/*
  Конвейер, открытый из реестра кнопкой «В конвейер» (16.10.2026).

  Правила очереди кнопка не меняет (решение владельца): в очередь к подаче
  счёт ставит разбор, а не человек. Поэтому здесь два ответа - кто из
  выбранных в очереди (они ниже и уже отмечены) и кого в ней нет и почему.
  Причину называет сервер по тому же условию, что строит очередь.
*/

import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { api } from '../api/client.js'
import { accounts } from '../api/format.js'

const NAMED = 10

/* Счета приходят из реестра в состоянии перехода (`navigate(..., { state })`),
   а не в адресе: сотня идентификаторов в адресе страницы упёрлась бы в предел
   его длины. «Показать всю очередь» снимает их тем же переходом. */
export function useConveyorChosen() {
  const navigate = useNavigate()
  const ids = useLocation().state?.chosen
  const [chosen, setChosen] = useState(null)
  const [error, setError] = useState(null)
  const showAll = () => navigate('/conveyor', { replace: true, state: null })

  useEffect(() => {
    if (!ids?.length) return undefined
    let current = true
    api
      .conveyorChosen(ids)
      .then((result) => current && setChosen(result))
      .catch((failure) => current && setError(failure))
    return () => {
      current = false
    }
  }, [ids])

  // Выбор снят («Показать всю очередь») - прежний ответ больше не о чем.
  return ids?.length
    ? { ids, chosen, error, showAll }
    : { ids: null, chosen: null, error: null, showAll }
}

export default function ConveyorChosen({ chosen, total, onShowAll }) {
  const outside = chosen.outside
  return (
    <div className={`notice notice--${outside.length ? 'warn' : 'ok'} notice--wide`}>
      <div className="notice__what">
        Из реестра выбрано {accounts(total)}. В очереди к подаче {chosen.queue.length}
        {chosen.queue.length ? ' - они ниже и уже отмечены.' : '.'}
      </div>
      {outside.length ? (
        <>
          <div className="notice__do">Не в очереди ({outside.length}):</div>
          <ul className="list-plain">
            {outside.slice(0, NAMED).map((row) => (
              <li key={row.account_id}>
                № {row.number} - {row.reason}
              </li>
            ))}
          </ul>
          {outside.length > NAMED ? (
            <div className="notice__do">и ещё {accounts(outside.length - NAMED)}.</div>
          ) : null}
        </>
      ) : null}
      <button type="button" className="button button--quiet" onClick={onShowAll}>
        Показать всю очередь
      </button>
    </div>
  )
}
